import { render, staticRenderFns } from "./privilegeManagement.vue?vue&type=template&id=7b407830&scoped=true"
import script from "./privilegeManagement.vue?vue&type=script&lang=js"
export * from "./privilegeManagement.vue?vue&type=script&lang=js"
import style0 from "./privilegeManagement.vue?vue&type=style&index=0&id=7b407830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b407830",
  null
  
)

export default component.exports